(function() {
	'use strict';

	angular.module('paxMessageConfig').config(config);

	function config($stateProvider) {
		$stateProvider.state('paxMessageConfig', {
			url : '/pax-message-config',
			views : {
				'paxMessageConfigView' : {
					templateUrl : 'pax-message-config/views/pax-message-config.tpl.html',
					controller : 'PaxMessageConfigCtrl',
					controllerAs : 'paxMessageConfig'
				}
			}

		});
	}
}());